export default __webpack_public_path__ + "static/technomedics-icon-c12415c5032032f7834982dfe35b46d7.png";